<template>
  <div class="m_footer">
    <div class="m_menu">
      <div class="menu_list">
        <div class="menu-item" v-for="(item, i) in menuList" :key="i">
          <div class="menu-main">{{ item.title }}</div>
          <ul id="menu">
            <li @click="toRouter(item, sub, j)" class="menu-sub" v-for="(sub, j) in item.sub" :key="j">
              <a class="text" href="javascript: void(0)">{{ sub.txt }}</a>
            </li>
          </ul>
        </div>
      </div>
      <div class="m_desc">
        <div class="logo">
          <img src="@/assets/mobile/logo_m.svg" alt="" />
          <div class="desc">
            <div>创新融合ABC技术</div>
            <div>打造新一代软件定义的实验室自动化暨数字化体系</div>
          </div>
          <div class="btn">
            <el-button class="btn_text" type="primary" @click="toConnect">联系我们</el-button>
          </div>
        </div>
      </div>
      <div class="m_text">
        <div class="footer_text">Copyright © 2023,广州合木仟行科技有限公司®.All rights reserved.</div>
        <a href="https://beian.miit.gov.cn/" rel="nofollow" target="_blank">粤ICP备2021112945号-1</a>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      menuList: [
        {
          title: '快速入口 ',
          name: 'home',
          sub: [
            // footer 相关模块入口路由
            { txt: '首页', link: '/#' },
            { txt: '应用案例', link: '/#' },
            { txt: '公司介绍', link: '/#' },
            { txt: '加入合木', link: '/#' }
          ]
        },
        {
          title: '水星计划',
          name: 'plan',
          sub: [
            { txt: '关于水星计划', link: '#' },
            { txt: '水星计划开发服务', link: '#' }
          ]
        },
        {
          title: '实验与诊断智能',
          name: 'molecule',
          sub: [
            { txt: 'ACE Line', link: '#' }, // id="zhengshu"
            { txt: 'Lib Master', link: '#' },
            { txt: 'Gemini', link: '#' }
          ]
        },
        {
          title: '生物制造工艺',
          name: 'biology',
          sub: [
            { txt: 'Combo-E', link: '#' },
            { txt: 'Combo-Q', link: '#' },
            { txt: 'Combo-G', link: '#' },
            { txt: 'Combo-M', link: '#' },
            { txt: 'Flex-SC', link: '#' },
            { txt: 'Flex-CG', link: '#' }
          ]
        }
      ]
    };
  },
  methods: {
    toRouter(item, sub, i) {
      const name = item.name; //一级
      // sub 二级
      if (name == 'home') {
        console.log(sub, i, 122111);
        if (i == 1) {
          this.$router.push({
            // path: '/case'
            path: '/about/about-introduce'
          });
          document.querySelector('.navbar-box').className = 'navbar-box';
        } else if (i == 2) {
          this.$router.push({
            path: '/about/about-introduce'
          });
          document.querySelector('.navbar-box').className = 'navbar-box';
        } else if (i == 0) {
          this.$router.push({
            path: '/home'
          });
          document.querySelector('.navbar-box').className = 'navbar-box';
        } else if (i == 3) {
          this.$router.push({
            path: '/about/about-join'
          });
          document.querySelector('.navbar-box').className = 'navbar-box';
        } else {
          this.$router.push({
            path: '/home'
          });
          document.querySelector('.navbar-box').className = 'navbar-box';
        }
      } else if (name == 'plan') {
        if (i == 0) {
          this.$router.push({
            path: '/mercury-project/about'
          });
          document.querySelector('.navbar-box').className = 'navbar-box';
        } else if (i == 1) {
          this.$router.push({
            path: '/mercury-project/service'
          });
          document.querySelector('.navbar-box').className = 'navbar-box';
        }
      } else if (name == 'molecule') {
        if (i == 0) {
          this.$router.push({
            path: '/bioengineering-technology',
            query: { name: 'ACE Line' }
          });
        }
        if (i == 1) {
          this.$router.push({
            path: '/bioengineering-technology',
            query: { name: 'Lib Master' }
          });
        }
        if (i == 2) {
          this.$router.push({
            path: '/bioengineering-technology',
            query: { name: 'Gemini' }
          });
        }
      } else if (name == 'biology') {
        if (i == 0) {
          this.$router.push({
            path: '/bioengineering-technology',
            query: { name: 'Combo-E' }
          });
        }
        if (i == 1) {
          this.$router.push({
            path: '/bioengineering-technology',
            query: { name: 'Combo-Q' }
          });
        }
        if (i == 2) {
          this.$router.push({
            path: '/bioengineering-technology',
            query: { name: 'Combo-G' }
          });
        }
        if (i == 3) {
          this.$router.push({
            path: '/bioengineering-technology',
            query: { name: 'Combo-M' }
          });
        }
        if (i == 4) {
          this.$router.push({
            path: '/bioengineering-technology',
            query: { name: 'Flex-SC' }
          });
        }
        if (i == 5) {
          this.$router.push({
            path: '/bioengineering-technology',
            query: { name: 'Flex-CG' }
          });
        }
      }
    },
    dialogClick() {
      this.Visible = true;
    },
    toConnect() {
      this.$router.push('/about/contact');
      document.querySelector('.navbar-box').className = 'navbar-box';
    }
  }
};
</script>

<style lang="less" scoped>
.el-button--primary {
  width: 176px;
  height: 56px;
  margin-bottom: 80px;
}
.m_footer {
  height: auto;
  width: auto;
  // display: flex;
  background-color: #112448;
  // flex-direction: row;
  .m_menu {
    .menu_list {
      padding: 40px 54px 80px 54px;
      border-bottom: 1px solid rgba(255, 255, 255, 0.1);
    }
    .menu-item {
      font-size: 14px;
      margin-bottom: 40px;
      #menu {
        margin: auto;
        display: flex;
        flex-wrap: wrap;
        justify-content: left;
        margin-top: 24px;
      }
      .menu-main {
        margin-bottom: 8px;
        font-family: 'PingFang SC';
        font-style: normal;
        font-weight: 500;
        font-size: 24px;
        line-height: 28px;
        color: #ffffff;
      }
      .text {
        font-family: 'PingFang SC';
        font-style: normal;
        font-weight: 400;
        font-size: 28px;
        line-height: 32px;
        color: rgba(255, 255, 255, 0.6);
      }
      .menu-sub a:hover {
        color: #ffffff;
      }

      ul {
        display: flex;
        gap: 32px;
        flex-wrap: wrap;
      }
      ul > li {
        justify-content: left;
      }
      ul > li > a {
        font-family: 'PingFang SC';
        font-style: normal;
        font-weight: 400;
        font-size: 28px;
        line-height: 32px;
        color: rgba(255, 255, 255, 0.6);
      }
    }
  }
  .menu-item + .menu-item {
    font-size: 14px;
  }
  .m_desc {
    display: flex;
    justify-content: center;
    .logo {
      text-align: center;
      padding: 80px 54px 0 54px;
      .desc {
        font-family: 'PingFang SC';
        font-style: normal;
        font-weight: 500;
        font-size: 28px;
        line-height: 46px;
        text-align: center;
        color: #ffffff;
        margin-bottom: 32px;
      }
      .btn {
        display: flex;
        justify-content: center;
        .btn_text {
          background: #009aef;
          border-radius: 4px;
          font-family: 'PingFang SC';
          font-style: normal;
          font-weight: 500;
          font-size: 20px;
          line-height: 24px;
          color: #ffffff;
          display: flex;
          justify-content: center;
          align-items: center;
        }
      }
      img {
        width: 230px;
        height: 80px;
      }
    }
  }
  .m_text {
    text-align: center;
    font-family: 'PingFang SC';
    font-style: normal;
    font-weight: 400;
    font-size: 20px;
    line-height: 28px;
    padding-bottom: 40px;
    color: rgba(255, 255, 255, 0.6);
    .footer_text {
      margin-bottom: 8px !important;
    }
    a {
      color: rgba(255, 255, 255, 0.6);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/mobile/footer/footer.vue